<template>
    <div v-if="isLoaded">
        <div class="content-body"
             v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card"
                         style="">
                        <div class="card-header">
                            <v-tour name="blogisticTour"
                                    :steps="steps"
                                    :callbacks="callbacksTour"></v-tour>
                            <h4 class="card-title">Config FTP</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()"
                                           v-b-tooltip
                                           title="Cadastrar"><i class="ft-plus"
                                               v-if="getPermission('configftp.store')"></i></a></li>
                                    <li><a @click="onActivateDesactivate(1, null, false)"
                                           v-b-tooltip
                                           title="Ativar Registros"
                                           v-if="getPermission('configftp.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                    <li><a @click="onActivateDesactivate(2, null, false)"
                                           v-b-tooltip
                                           title="Inativar Registros"
                                           v-if="getPermission('configftp.status')"><i class="fa fa-thumbs-o-down"></i></a></li>
                                    <li><a @click="expandFullscreen()"
                                           v-b-tooltip
                                           title="Expande a tela"
                                           v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()"
                                           v-b-tooltip
                                           title="Minimiza a tela"
                                           v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()"
                                           v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData"
                                         v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData"
                                                     text-fg-color="#ffffff"
                                                     message="Carregando..."></spinner>
                                        </div>
                                    </div>

                                    <vuetable ref="vuetable"
                                              api-url="/api/configftp"
                                              :fields="fields"
                                              :css="css"
                                              :append-params="moreParams"
                                              track-by="conftp_id"
                                              pagination-path=""
                                              @vuetable:load-error="onError"
                                              @vuetable:pagination-data="onPaginationData"
                                              @vuetable:loaded="onLoaded">
                                      <template slot="status" slot-scope="props">
                                          <span class="badge badge-success" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-danger" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                        </template>
                                      <template slot="actions" slot-scope="props">
                                        <div class="custom-actions">
                                            <a @click="onEdit(props.rowData, props.rowIndex)" v-b-tooltip title="Editar" v-if="getPermission('configftp.update')"><i class="fa fa-edit"></i></a>
                                            <div v-if="getPermission('configftp.status')">
                                                <a v-if="props.rowData.status.valor==2" @click="onActivateDesactivate(1, props.rowData, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                                <a v-if="props.rowData.status.valor==1" @click="onActivateDesactivate(2, props.rowData, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                            </div>
                                            <a v-if="getPermission('configftp.test')" @click="onTestarFtp(props.rowData)" v-b-tooltip title="Testar FTP"><i class="fa fa-send"></i></a>
                                          </button>
                                        </div>
                                      </template>
                                    </vuetable>
                                </div>
                                <div>
                                    <div class='col-md-12'>
                                        <div class="pull-left pagination-detail">
                                            <vuetable-pagination-info ref="paginationInfo"
                                                                      :css="css.pagination"
                                                                      info-class="pull-left"></vuetable-pagination-info>
                                        </div>
                                        <div class="pull-right m-a-0">
                                            <vuetable-pagination ref="pagination"
                                                                 :css="css.pagination"
                                                                 @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Modal Component -->
            <b-modal id="modal_form"
                     ref="modal_form"
                     size="lg"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     cancel-title="Cancelar"
                     :ok-disabled=form.errors.any()
                     v-model="showModal"
                     @ok="handleOk">


                <form @submit.stop.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)">
            <b-container fluid class="p-a-0">
            <b-row>
            <b-col>
                    <b-form-text>Código</b-form-text>
                    <b-form-input type="text"
                                  placeholder="Código"
                                  v-model="form.cd"
                                  name="cd"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>
            </b-col>
            <b-col class="p-l-0">
                    <b-form-text>Descrição</b-form-text>
                    <b-form-input type="text"
                                  placeholder="Descrição"
                                  v-model="form.descr"
                                  name="descr"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>
            </b-col>
            <b-col class="p-l-0">
                    <b-form-text>Host</b-form-text>
                    <b-form-input type="text"
                                  placeholder="Host"
                                  v-model="form.host"
                                  name="host"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('host')" v-if="form.errors.has('host')"></b-form-feedback>
            </b-col>
            </b-row>
            </b-container>

            <b-container fluid class="p-a-0">
            <b-row>
            <b-col>
                    <b-form-text>User</b-form-text>
                    <b-form-input type="text"
                                  placeholder="User"
                                  v-model="form.user_"
                                  name="user_"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('user_')" v-if="form.errors.has('user_')"></b-form-feedback>
            </b-col>
            <b-col class="p-l-0">
                    <b-form-text>Pass</b-form-text>
                    <b-form-input type="text"
                                  placeholder="Pass"
                                  v-model="form.pass"
                                  name="pass"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('pass')" v-if="form.errors.has('pass')"></b-form-feedback>
            </b-col>
            </b-row>
            </b-container>

            <b-container fluid class="p-a-0">
            <b-row>
            <b-col>
                    <b-form-text>Folder</b-form-text>
                    <b-form-input type="text"
                                  placeholder="Folder"
                                  v-model="form.folder"
                                  name="folder"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('folder')" v-if="form.errors.has('folder')"></b-form-feedback>
            </b-col>
            <b-col class="p-l-0">
                    <b-form-text>Folder Backup</b-form-text>
                    <b-form-input type="text"
                                  placeholder="Folder Backup"
                                  v-model="form.folder_backup"
                                  name="folder_backup"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('folder_backup')" v-if="form.errors.has('folder_backup')"></b-form-feedback>
            </b-col>
            </b-row>
            </b-container>

            <b-container fluid class="p-a-0">
            <b-row>
            <b-col>
                    <b-form-text>Folder Interno</b-form-text>
                    <b-form-input type="text"
                                  placeholder="Folder Interno"
                                  v-model="form.folder_interno"
                                  name="folder_interno"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('folder_interno')" v-if="form.errors.has('folder_interno')"></b-form-feedback>
            </b-col>
            <b-col class="p-l-0">
                      <b-form-text>Folder Interno Backup</b-form-text>
                      <b-form-input type="text"
                                    placeholder="Folder Interno Backup"
                                    v-model="form.folder_interno_backup"
                                    name="folder_interno_backup"
                                    >
                      </b-form-input>
                      <b-form-feedback class="text-danger" v-text="form.errors.get('folder_interno_backup')" v-if="form.errors.has('folder_interno_backup')"></b-form-feedback>
              </b-col>
            </b-col>
            </b-row>
            </b-container>

            <b-container fluid class="p-a-0">
            <b-row>
            <b-col>
                    <b-form-text>Extensão</b-form-text>
                    <b-form-input type="text"
                                  placeholder="Extensão"
                                  v-model="form.extensao"
                                  name="extensao"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('extensao')" v-if="form.errors.has('extensao')"></b-form-feedback>
            </b-col>
            <b-col class="p-l-0">
              <b-form-text>Tipo Operação</b-form-text>
              <multiselect v-model="form.tp_operacao"
              :options="optionsLivTipoOperacao"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              ></multiselect>
              <b-form-feedback class="text-danger" v-text="form.errors.get('tp_operacao')" v-if="form.errors.has('tp_operacao')"></b-form-feedback>
            </b-col>
            </b-row>
            </b-container>

            <b-container fluid class="p-a-0">
            <b-row>
            <b-col>

            <b-form-text>Status</b-form-text>
            <multiselect v-model="form.status"
            :options="optionsLivStatus"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            ></multiselect>
            <b-form-feedback class="text-danger" v-text="form.errors.get('status')" v-if="form.errors.has('status')"></b-form-feedback>

          </b-col>
          </b-row>
          </b-container>

            </form>
            <div slot="modal-footer" class="w-100">
                   <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                   <div class="float-right">
                       <b-btn @click="showModal=false" variant="secondary">
                         Fechar
                       </b-btn>
                       <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                         Enviar
                       </b-btn>
                   </div>
            </div>
        </b-modal>
        </div>
    </div>
</template>

<script>
    import Vuetable from '../components/Vuetable'
    import VuetablePagination from '../components/VuetablePagination'
    import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
    import ConfigFtpFilterBar from './ConfigFtpFilterBar'

    export default {
        components: {
            Vuetable,
            VuetablePagination,
            VuetablePaginationInfo,
            'vuetable-filterbar': ConfigFtpFilterBar,
        },
        data() {
            return {
                modal_titulo: '',
                modal_botao: '',
                modal_acao: '',
                loading: false,
                isDisabled: false,
                loadingData: true,
                showModal: false,
                isFullscreen: false,
                optionsLivStatus: [],
                optionsLivTipoOperacao: [],
                activateDesativate: [],
                helpForm: new Form({
                    statusRecord: [],
                    params: []
                }),
                form: new Form({
                    cd: '',
                    descr: '',
                    host: '',
                    user_: '',
                    pass: '',
                    folder: '',
                    folder_interno: '',
                    folder_interno_backup: '',
                    folder_backup: '',
                    extensao: '',
                    tp_operacao: [],
                    status: []
                }),
                fields: [{
                        name: 'cd',
                        title: 'Código',
                        sortField: 'cd'
                    },
                    {
                        name: 'descr',
                        title: 'Descrição',
                        sortField: 'descr'
                    },
                    {
                        name: 'host',
                        title: 'Host',
                        sortField: 'host'
                    },
                    {
                        name: 'user_',
                        title: 'User',
                        sortField: 'user_'
                    },
                    {
                        name: 'folder',
                        title: 'Folder',
                        sortField: 'folder'
                    },
                    {
                        name: 'folder_backup',
                        title: 'Folder Backup',
                        sortField: 'folder_backup'
                    },
                    {
                        name: 'folder_interno',
                        title: 'Folder Interno',
                        sortField: 'folder_interno'
                    },
                    {
                        name: 'folder_interno_backup',
                        title: 'Folder Interno Backup',
                        sortField: 'folder_interno_backup'
                    },
                    {
                        name: 'extensao',
                        title: 'Extensão',
                        sortField: 'extensao'
                    },
                    {
                        name: 'liv_tipo_operacao.descr',
                        title: 'Tipo Operação',
                        sortField: 'liv_tipo_operacao'
                    },
                    {
                        name: '__slot:status',
                        title: 'Status',
                        sortField: 'status'
                    },
                    {
                        name: '__slot:actions',
                        title: 'Ações',
                        titleClass: 'center aligned',
                        dataClass: 'center aligned'
                    }
                ],
                css: {
                    tableClass: 'table table-striped',
                    loadingClass: 'loading',
                    ascendingIcon: 'glyphicon glyphicon-chevron-up',
                    descendingIcon: 'glyphicon glyphicon-chevron-down',
                    handleIcon: 'glyphicon glyphicon-menu-hamburger',
                },
                moreParams: {}
            }
        },
        mounted() {
            this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
            this.$events.$on('filter-reset', e => this.onFilterReset());
            this.getLivStatus();
            this.getTipoOperacao();
        },
        methods: {
            onPaginationData(paginationData) {
                this.$refs.pagination.setPaginationData(paginationData)
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },
            onChangePage(page) {
                this.$refs.vuetable.changePage(page)
            },
            onFilterSet(data_filter) {
                this.loadingData = true;
                this.moreParams = {
                    'cd': data_filter.cd,
                    'host': data_filter.host,
                    'tipo_operacao': data_filter.tipo_operacao.value,
                    'descr': data_filter.descr,
                    'status': data_filter.status.value
                }
                Vue.nextTick(() => {
                    this.$refs.vuetable.refresh();
                })
            },
            onFilterReset() {
                this.loadingData = true;
                this.moreParams = {}
                Vue.nextTick(() => this.$refs.vuetable.refresh())
            },
            onFilterShowHide() {
                if (this.vuetableFilterRow) {
                    this.$store.commit('setVuetableFilterRow', false);
                } else {
                    this.$store.commit('setVuetableFilterRow', true);
                }
            },
            onLoaded: function() {
                this.dataExport = this.$refs.vuetable.tableData;
                this.loadingData = false;
                this.$store.commit('setVuetableFilterButton', false);
            },
            handleOk(e) {
                e.preventDefault();
                if (this.modal_acao == "i") {
                    this.onStore();
                } else {
                    this.onUpdate(this.form.conftp_id);
                }
            },
            onCreate() {
                this.isDisabled = false;
                this.loading = false;
                this.modal_titulo = "Cadastrar";
                this.modal_botao = "Cadastrar";
                this.modal_acao = "i";
                this.form.reset();
                this.$refs.modal_form.show();
            },
            onEdit(data, index) {
                this.isDisabled = false;
                this.loading = false;
                this.modal_titulo = "Alterar";
                this.modal_botao = "Alterar";
                this.modal_acao = "u";
                this.form.reset();
                this.form.cd = data.cd;
                this.form.descr = data.descr;
                this.form.host = data.host;
                this.form.user_ = data.user_;
                this.form.pass = data.pass;
                this.form.folder = data.folder;
                this.form.folder_backup = data.folder_backup;
                this.form.folder_interno = data.folder_interno;
                this.form.folder_interno_backup = data.folder_interno_backup;
                this.form.extensao = data.extensao;
                this.form.tp_operacao = {
                    label: data.liv_tipo_operacao.descr,
                    value: data.liv_tipo_operacao.valor
                };
                this.form.status = {
                    label: data.status.descr,
                    value: data.status.valor
                };
                this.form.conftp_id = data.conftp_id;
                this.$refs.modal_form.show();
            },
            onStore() {
                this.loading = true;
                this.isDisabled = true;
                this.form.post('/api/configftp/store').then(response => {
                        new ReturnApi(response, this)
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            onUpdate(id) {
                this.loading = true;
                this.isDisabled = true;
                this.form.post('/api/configftp/update/' + id).then(response => {
                        new ReturnApi(response, this)
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            getLivStatus() {
                this.helpForm.params = {
                    tabela: 'config_ftp',
                    coluna: 'status'
                };

                this.helpForm.get('/api/listitemvalor/jsonlist').then(response => {
                        new ReturnApi(response, this, true, false, false);
                        response.items.forEach((obj) => {
                            this.optionsLivStatus.push({
                                label: obj.descr,
                                value: obj.valor
                            })
                        })
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            getTipoOperacao() {
                this.helpForm.params = {
                    tabela: 'config_ftp',
                    coluna: 'tp_operacao'
                };

                this.helpForm.get('/api/listitemvalor/jsonlist').then(response => {
                        new ReturnApi(response, this, true, false, false);
                        response.items.forEach((obj) => {
                            this.optionsLivTipoOperacao.push({
                                label: obj.descr,
                                value: obj.valor
                            })
                        })
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            onTestarFtp(data) {
                this.helpForm.post('/api/configftp/test/' + data.conftp_id).then(response => {
                        new ReturnApi(response, this, true, false, false);
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            onActivateDesactivate(action, data, tipo) {
                // Tipo = true = Checkbox
                if (tipo) {
                    this.helpForm.statusRecord = [];
                    this.helpForm.statusRecord.push({
                        id: data.conftp_id,
                        status: action
                    });
                } else {
                    this.helpForm.statusRecord = [];
                    this.$refs.vuetable.selectedTo.forEach((obj) => {
                        this.helpForm.statusRecord.push({
                            id: obj,
                            status: action
                        })
                    });
                }

                this.helpForm.post('/api/configftp/status').then(response => {
                        new ReturnApi(response, this)
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            onError(response) {
                new ReturnApi(response.response, this, true, true, false);
            },
            getPermission(checkPermission) {
                return this.getPermissionFw(checkPermission);
            },
        },
        computed: {
            vuetableFilterRow: {
                get() {
                    return this.$store.state.vuetable.filterRow;
                },
            },
            isLoaded: {
                get() {
                    return this.$store.getters.isloaded;
                }
            }
        }
    }

</script>
